export default __webpack_public_path__ + "static/media/logo-nusa-parking.a52f8f91.png";